import * as storageActionCreatorCreators from 'app/models/storage/actions';
import { parseStorageValue } from 'app/models/storage/selectors';
import {
  addLocalStorageListener,
  getDangerousNativeLocalStorage,
  isStorageClearEvent,
} from 'app/utils/env';
import {
  INIT,
  SET_ITEM,
  REMOVE_ITEM,
  CLEAR,
  Storage,
  validateKey,
} from 'app/models/localStorage/constants';
import {
  getItem,
  wasLocalStorageInitiallyAvailable,
} from 'app/models/localStorage/selectors';
import { createMockableFunction } from 'app/utils/mock';
import { AppThunk } from 'app/store';

export const initAction = (
  wasStorageInitiallyAvailable: boolean,
  storageCopy: { [key: string]: unknown },
) => ({
  type: INIT,
  wasStorageInitiallyAvailable,
  storageCopy,
});

export const setItemAction = (key: string | null, value: string | null) => ({
  type: SET_ITEM,
  key,
  value,
});

export const removeItemAction = (key: string | null) => ({
  type: REMOVE_ITEM,
  key,
});

export const clearAction = () => ({ type: CLEAR });

/**
 * The init action creator, generated from the common storage actions.
 * Check the common storage actions file for more details.
 */
export const init = (): AppThunk<void> => (dispatch) => {
  dispatch(storageActionCreatorCreators.init(
    Storage,
    getDangerousNativeLocalStorage,
    initAction,
    getItem,
  )());

  addLocalStorageListener((storageEvent) => {
    const { key, newValue } = storageEvent;

    if (isStorageClearEvent(storageEvent)) {
      dispatch(clearAction());
    } else if (Storage.has(key)) {
      if (newValue) {
        dispatch(setItemAction(key, parseStorageValue(key, newValue)));
      } else {
        dispatch(removeItemAction(key));
      }
    }
  });
};

/**
 * @deprecated Use StorageContext instead
 */
export const setItem = createMockableFunction(storageActionCreatorCreators.setItem(
  validateKey,
  wasLocalStorageInitiallyAvailable,
  getDangerousNativeLocalStorage,
  setItemAction,
));

/**
 * @deprecated Use StorageContext instead
 */
export const removeItem = createMockableFunction(storageActionCreatorCreators.removeItem(
  validateKey,
  wasLocalStorageInitiallyAvailable,
  getDangerousNativeLocalStorage,
  setItemAction,
));
